import { ENVIRONMENT_LABEL_KEY } from 'src/common/consts/platformConfigConsts';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { ConditionDateTime, ConditionInt } from 'src/common/types/graphql.generated';

import { ScoreDataQueryVariables } from '../ScoreData.generated';

export const buildScoreDataVariables = (
	filters?: IFilterOptions,
	dateFrom?: string,
	dateTo?: string,
	timeframeDays?: number
): ScoreDataQueryVariables => {
	const variables: Partial<ScoreDataQueryVariables> = {};

	if (filters?.unitId && filters.unitId.length > 0 && filters.unitId[0]?.value) {
		const unitIdValue = String(filters.unitId[0].value);
		variables.unitIdFilter = { value: [unitIdValue] };
	} else {
		variables.unitIdFilter = { value: [''] };
	}

	// Handle environment filter
	const environmentFilter = filters?.[ENVIRONMENT_LABEL_KEY as keyof IFilterOptions] as
		| Array<{ value: string; label: string }>
		| undefined;
	if (environmentFilter && environmentFilter.length > 0 && environmentFilter[0]?.value) {
		const values = environmentFilter.flatMap((opt) => {
			const original = String(opt.value);
			const lower = original.toLowerCase();
			return lower !== original ? [original, lower] : [original];
		});
		variables.environmentFilter = { value: values };
	} else {
		variables.environmentFilter = undefined;
	}

	if (dateFrom) {
		variables.calculationDateFrom = {
			value: [dateFrom]
		} as ConditionDateTime;
	} else {
		variables.calculationDateFrom = undefined;
	}

	if (dateTo) {
		variables.calculationDateTo = {
			value: [dateTo]
		} as ConditionDateTime;
	} else {
		variables.calculationDateTo = undefined;
	}

	if (timeframeDays !== undefined && timeframeDays !== null) {
		variables.timeframeDaysFilter = {
			value: [timeframeDays]
		} as ConditionInt;
	} else {
		variables.timeframeDaysFilter = undefined;
	}

	return variables as ScoreDataQueryVariables;
};
